enum Status {
  Lobby,
  PreGame,
  Playing,
  Spectating,
  Replay,
  SharedReplay,
}
export default Status;

export const StatusText = [
  "Lobby",
  "Pre-Game",
  "Playing",
  "Spectating",
  "Replay",
  "Shared Replay",
];
